export function shampooMBTI() {
  return {
    currentScreen: 'quiz',
    currentQuestion: 0,
    answers: [],
    offerOpen: false,
    result: {
      type: '',
      title: '',
      subtitle: '',
      description: '',
      traits: [],
      recommendation: '',
      offer: null,
    },

    // ✅ 12문항으로 확장 (정확도 향상)
    questions: [
      // 지성 관련 (3문항)
      { id: 'oil1', question: '아침에 감아도 저녁이면 정수리가 금방 떡진다' },
      {
        id: 'oil2',
        question: '머리를 하루만 안 감아도 기름져 보인다는 말을 들은 적이 있다',
      },
      {
        id: 'oil3',
        question: '샴푸 후 6시간이 지나면 두피가 번들거리는 느낌이 든다',
      },

      // 민감 관련 (3문항)
      {
        id: 'sensitive1',
        question: '환절기나 스트레스 받을 때 두피가 가렵거나 따갑다',
      },
      {
        id: 'sensitive2',
        question: '샴푸를 바꾸면 두피가 예민하게 반응하는 편이다',
      },
      {
        id: 'sensitive3',
        question: '비듬이나 각질이 자주 생기거나 두피가 빨개진다',
      },

      // 손상 관련 (3문항)
      {
        id: 'damage1',
        question: '머리카락을 살짝 당기면 탄력 없이 끊어지는 느낌이 든다',
      },
      { id: 'damage2', question: '드라이기나 고데기를 거의 매일 사용한다' },
      {
        id: 'damage3',
        question: '염색이나 펌을 자주 하는 편이다 (최근 3개월 이내 시술)',
      },

      // 복합 & 건강도 체크 (3문항)
      {
        id: 'lifestyle1',
        question: '왁스·에센스·스프레이 같은 스타일링 제품을 자주 사용한다',
      },
      {
        id: 'lifestyle2',
        question: '샴푸 후 두피가 개운하기보다 땅기거나 불편하다',
      },
      {
        id: 'lifestyle3',
        question: '정수리 냄새나 두피 냄새를 신경 써본 적이 있다',
      },
    ],

    results: {
      OILY: {
        type: '지성-산뜻 타입',
        title: '쿨링 케어가 필요해요!',
        subtitle: '유분이 빠르게 올라오는 두피',
        description:
          '두피 유분이 빠르게 올라오면 모공이 막히고 냄새도 신경 쓰이죠. 지금은 깨끗한 세정과 쿨링 케어로 산뜻함을 되찾아보세요!',
        traits: [
          '저자극 딥클렌징 (과한 세정은 NO)',
          '피지 밸런스 + 시원한 쿨링감',
          '샴푸 후 두피 완전 건조',
          '주 1~2회 두피 스케일링',
        ],
        recommendation:
          '산뜻한 쿨링 샴푸와 두피 스케일링으로 모공 케어를 추천해요.',
        offer: {
          product: '쿨링 지성 샴푸 / 스케일링 샴푸',
          service: '두피 스케일링 + 쿨링 케어 (10~15분)',
          note: '스타일링 제품을 줄이고, 드라이를 꼼꼼히 하면 훨씬 오래 가요!',
        },
      },

      SENSITIVE: {
        type: '민감-진정 타입',
        title: '두피가 예민해졌어요',
        subtitle: '가려움·따가움이 느껴지는 타입',
        description:
          '환절기나 스트레스를 받으면 두피 장벽이 약해져서 가렵고 따가울 수 있어요. 지금은 자극 없는 진정 케어가 우선이에요.',
        traits: [
          '약산성 저자극 세정',
          '진정 성분으로 두피 안정',
          '뜨거운 물·강한 문지름 피하기',
          '샴푸 교체 시 패치테스트 필수',
        ],
        recommendation:
          '저자극 진정 샴푸와 가벼운 두피 팩으로 컨디션을 회복해 보세요.',
        offer: {
          product: '저자극 진정 샴푸 / 약산성 샴푸',
          service: '진정 두피 팩 + 쿨다운 케어 (8~12분)',
          note: '염색·펌 직후 1~2주는 진정 라인으로 관리하면 좋아요.',
        },
      },

      DAMAGED: {
        type: '손상-영양 타입',
        title: '모발이 영양을 원해요!',
        subtitle: '열·손상으로 탄력이 떨어진 타입',
        description:
          '끊어지는 느낌이 든다면 단백질과 수분 밸런스가 무너진 신호예요. 지금은 영양과 탄력을 채워주는 집중 케어가 필요해요.',
        traits: [
          '단백질 + 보습 밸런스',
          '열기구 사용 줄이기',
          '트리트먼트 시간 넉넉히',
          '주 2~3회 집중 영양 케어',
        ],
        recommendation:
          '단백질 샴푸와 트리트먼트를 5분 이상 방치하면 효과가 좋아요!',
        offer: {
          product: '단백질 샴푸 / 딥 트리트먼트',
          service: '클리닉 (단백질·보습) + 홈케어 처방 (20~25분)',
          note: "주 1~2회는 '집중 케어 데이'로 정해두면 회복이 빨라져요.",
        },
      },

      HEALTHY: {
        type: '건강-힐링 타입',
        title: '지금 상태를 유지하세요!',
        subtitle: '균형 잡힌 건강한 두피와 모발',
        description:
          '축하해요! 두피와 모발이 건강한 상태예요. 지금의 좋은 컨디션을 유지하면서 가끔씩 영양 충전으로 더욱 윤기 있게 가꿔보세요.',
        traits: [
          '순한 데일리 샴푸로 현상 유지',
          '주 1회 가벼운 영양 케어',
          '계절 변화에 맞춰 제품 조정',
          '예방 차원의 두피 마사지',
        ],
        recommendation:
          '밸런스 샴푸와 가벼운 트리트먼트로 건강함을 지켜보세요.',
        offer: {
          product: '밸런스 샴푸 / 라이트 트리트먼트',
          service: '힐링 두피 마사지 + 영양 케어 (10~15분)',
          note: '건강할 때 예방 관리가 중요해요. 월 1회 두피 케어를 추천드려요!',
        },
      },
    },

    get progress() {
      return ((this.currentQuestion + 1) / this.questions.length) * 100;
    },

    startQuiz() {
      this.currentScreen = 'quiz';
    },

    selectAnswer(val) {
      this.answers[this.currentQuestion] = val;
      setTimeout(() => this.nextQuestion(), 120);
    },

    nextQuestion() {
      if (this.currentQuestion < this.questions.length - 1) {
        this.currentQuestion++;
        this.offerOpen = false;
      } else {
        this.calculateResult();
      }
    },

    prevQuestion() {
      if (this.currentQuestion > 0) {
        this.currentQuestion--;
        this.offerOpen = false;
      }
    },

    // ✅ 12문항 기반 정교한 스코어링
    calculateResult() {
      this.currentScreen = 'calculating';
      this.offerOpen = false;

      setTimeout(() => {
        const score = { OILY: 0, SENSITIVE: 0, DAMAGED: 0, HEALTHY: 0 };
        const yes = (i) => this.answers[i] === true;

        // === 지성 타입 점수 ===
        // Q0: 떡짐 → 지성 강력
        if (yes(0)) score.OILY += 4;
        // Q1: 하루만 안 감아도 기름 → 지성 강력
        if (yes(1)) score.OILY += 4;
        // Q2: 6시간 후 번들 → 지성 중간
        if (yes(2)) score.OILY += 3;
        // Q9: 스타일링 제품 → 지성 보조
        if (yes(9)) score.OILY += 2;
        // Q11: 두피 냄새 → 지성 보조
        if (yes(11)) score.OILY += 2;

        // === 민감 타입 점수 ===
        // Q3: 가려움/따가움 → 민감 강력
        if (yes(3)) score.SENSITIVE += 4;
        // Q4: 샴푸 바꾸면 반응 → 민감 강력
        if (yes(4)) score.SENSITIVE += 4;
        // Q5: 비듬/각질/빨개짐 → 민감 강력
        if (yes(5)) score.SENSITIVE += 4;
        // Q10: 샴푸 후 땅김 → 민감 보조
        if (yes(10)) score.SENSITIVE += 2;

        // === 손상 타입 점수 ===
        // Q6: 끊어짐 → 손상 강력
        if (yes(6)) score.DAMAGED += 4;
        // Q7: 열기구 매일 → 손상 강력
        if (yes(7)) score.DAMAGED += 4;
        // Q8: 염색/펌 자주 → 손상 강력
        if (yes(8)) score.DAMAGED += 4;

        // === 건강 타입 점수 ===
        // 모든 문항이 No면 건강 타입 (기본 점수 부여)
        const totalYes = this.answers.filter((a) => a === true).length;

        if (totalYes === 0) {
          // 완전 건강 → 건강 타입 확정
          score.HEALTHY = 20;
        } else if (totalYes <= 2) {
          // 경미한 증상 → 건강 타입 가능성
          score.HEALTHY = 10;
        } else if (totalYes <= 4) {
          // 중간 정도 → 건강 타입 약간 가능
          score.HEALTHY = 5;
        }

        // 추가: 핵심 문항이 모두 No면 건강 보너스
        const coreSymptoms = [0, 1, 3, 4, 5, 6, 7, 8]; // 핵심 증상 문항들
        const hasCoreSymptom = coreSymptoms.some((i) => yes(i));
        if (!hasCoreSymptom) {
          score.HEALTHY += 8;
        }

        // 최고 점수 타입 선택
        const order = ['OILY', 'SENSITIVE', 'DAMAGED', 'HEALTHY'];
        let picked = order[0];
        order.forEach((key) => {
          if (score[key] > score[picked]) picked = key;
        });

        // 동점 처리 (우선순위: SENSITIVE > DAMAGED > OILY > HEALTHY)
        if (score.SENSITIVE === score[picked] && score.SENSITIVE > 0) {
          picked = 'SENSITIVE';
        } else if (score.DAMAGED === score[picked] && score.DAMAGED > 0) {
          picked = 'DAMAGED';
        } else if (score.OILY === score[picked] && score.OILY > 0) {
          picked = 'OILY';
        }

        this.result = this.results[picked];
        this.currentScreen = 'result';
      }, 1200);
    },

    openOffer() {
      this.offerOpen = !this.offerOpen;
    },

    restart() {
      this.currentScreen = 'intro';
      this.currentQuestion = 0;
      this.answers = [];
      this.offerOpen = false;
      this.result = {
        type: '',
        title: '',
        subtitle: '',
        description: '',
        traits: [],
        recommendation: '',
        offer: null,
      };
    },
  };
}
